<div>
  <custom-label *ngIf="placeholder" [placeholder]="placeholder"></custom-label>
  <p-dropdown
    [options]="data"
    [optionLabel]="label"
    [filter]="filterBy ? true : false"
    [filterBy]="filterBy"
    [placeholder]="dropdownMessage"
    [formControl]="value"

  ></p-dropdown>
</div>

